import { fetchApi } from '@/config/axiosSetting.ts';
import { BodyPersonalInformationOwnerType } from '@/modules/adjusterReportModules/Insurer-information/types/BodyOwnerType';

export const patchBodyOwnerUserInformationQueryFunction = (
  id: string,
  params: BodyPersonalInformationOwnerType,
) =>
  fetchApi({
    method: 'PATCH',
    url: `/body/reports/${id}/insurer_information/owner/personal_information/`,
    data: params,
  });
